<template>
  <div class="contactUs">
    <MdSolve  class="MD"/>
    <PcSolve class="PC"/>
  </div>
</template>

<script>
// 移动端
import MdSolve from './MdSolve.vue'
// pc端
import PcSolve from './PcSolve.vue'
// 引入获取解决方案类型
import { getSolve } from '@/api/solve'

export default {
  name: 'contactUs',
  components: {
    MdSolve,
    PcSolve
  },
  mounted () {
    this.getSolve()
  },
  methods: {
    async getSolve () {
      const res = await getSolve()
      // console.log(res, '解决详情类型')
      if (res.Msg === '获取成功') {
        this.$store.commit('getSolveTitle', res.Data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .contactUs{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .contactUs{
    .MD{
      display: none;
    }
  }
}
</style>
